import {Component, Input, Renderer2} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Editor} from 'ngx-editor';
import {environment} from 'src/environments/environment.prod';

@Component({
    selector: 'app-insert-emoji',
    templateUrl: './insert-emoji.component.html',
    styleUrls: ['./insert-emoji.component.scss'],
    standalone: false
})
export class InsertEmojiComponent {
  @Input() control: FormControl;
  @Input() editor: Editor | HTMLTextAreaElement;
  @Input() editorType: 'ngx' | 'textarea';

  picker: any;
  deployUrl: string;

  constructor(private renderer: Renderer2) {
    this.deployUrl = environment.deploy_url;
  }

  async togglePicker(event: MouseEvent) {
    try {
      if (!this.picker) {
        const {EmojiButton} = await import('@joeattardi/emoji-button');
        const targetElement = event.target as HTMLElement;
        const rect = targetElement.getBoundingClientRect();

        let topPosition = 0;
        if (rect.top + window.scrollY + 340 > window.screen.height) {
          topPosition = rect.top + window.scrollY;
          this.applyStyle();
        } else {
          topPosition = rect.top;
          this.removeStyle();
        }

        const leftPosition = rect.left + window.scrollX + 25;
        this.picker = new EmojiButton({
          position: {
            top: `${topPosition}px`,
            left: `${leftPosition}px`,
          },
        });

        this.picker.on('emoji', selection => {
          this.insertEmoji(selection.emoji);
        });
      }

      if (this.editorType === 'ngx') {
        this.picker.togglePicker(event.target as HTMLElement);
      } else if (this.editorType === 'textarea') {
        this.picker.togglePicker(this.editor as HTMLTextAreaElement);
      }
    } catch (error) {
      console.error('Failed to load EmojiButton:', error);
    }
  }

  private applyStyle() {
    const existingStyle = document.querySelector('#emoji-picker-styles');
    if (!existingStyle) {
      const styleElement = this.renderer.createElement('style');
      this.renderer.setAttribute(styleElement, 'id', 'emoji-picker-styles');

      const css = `
        .emoji-picker__wrapper {
          position: absolute !important;
        }
      `;
      styleElement.textContent = css;

      const head = this.renderer.selectRootElement('head', true);
      this.renderer.appendChild(head, styleElement);
    }
  }

  private removeStyle() {
    const existingStyle = document.querySelector('#emoji-picker-styles');
    if (existingStyle) {
      this.renderer.removeChild(document.head, existingStyle);
    }
  }

  private insertEmoji(emoji: string) {
    if (!this.editor || !this.control) {
      return;
    }

    if (this.editorType === 'ngx') {
      const ngxEditor = this.editor as Editor;
      ngxEditor.commands.insertText(emoji).exec();
    } else if (this.editorType === 'textarea') {
      const textarea = this.editor as HTMLTextAreaElement;
      const startPos = textarea.selectionStart;
      const endPos = textarea.selectionEnd;
      const currentValue = textarea.value;
      const textBefore = currentValue.substring(0, startPos);
      const textAfter = currentValue.substring(endPos, currentValue.length);
      const updatedValue = textBefore + emoji + textAfter;

      textarea.value = updatedValue;

      const newCursorPos = startPos + emoji.length;
      textarea.setSelectionRange(newCursorPos, newCursorPos);
      textarea.focus();

      this.control.setValue(updatedValue);
    }
  }
}
